import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import companyLogo from "../../images/logo/company-logo.png";
import { KOT_MAIN_URL } from "../../siteConfig";
import { Entity } from "../../data/companies";

// ============================================================
// Company site ki apni navigation: Home | KOT Global | Contact
// Logo: company ka apna (generator company-logo.png set karta hai)
// ============================================================

interface Props {
  entity: Entity;
}

const CompanyHeader: React.FC<Props> = ({ entity }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [mobileActive, setMobileActive] = useState(false);
  const lastScrollY = useRef<number>(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll < lastScrollY.current && currentScroll > 100) {
        setIsSticky(true);
        setTimeout(() => setIsVisible(true), 10);
      } else if (currentScroll > lastScrollY.current) {
        setIsVisible(false);
        setTimeout(() => setIsSticky(false), 100);
      }

      if (currentScroll <= 100) {
        setIsSticky(false);
        setIsVisible(false);
      }

      lastScrollY.current = currentScroll;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    setMobileActive(false);
    document
      .getElementById("contact")
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      id="xb-header-area"
      className="header-area header-style--one header-transparent is-sticky"
    >
      <div
        className={`xb-header xb-sticky-stt ${
          isSticky ? "xb-header-area-sticky" : ""
        } ${isVisible ? "xb-header-fixed" : "xb-header-hidden"}`}
      >
        <div className="container mxw-1650">
          <div className="header__wrap ul_li_between">
            {/* Company Logo */}
            <div className="xb-header-logo">
              <Link to="/" className="logo1" onClick={scrollTop}>
                <img
                  src={companyLogo}
                  alt={entity.name}
                  style={{
                    height: 52,
                    width: "auto",
                    background: "#fff",
                    padding: "8px 14px",
                    borderRadius: 10,
                  }}
                />
              </Link>
            </div>

            {/* Desktop nav — Home | KOT Global | Contact */}
            <div className="main-menu__wrap navbar navbar-expand-lg p-0">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  <li>
                    <Link to="/" onClick={scrollTop}>
                      <span>Home</span>
                    </Link>
                  </li>
                  <li>
                    <a
                      href={KOT_MAIN_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>KOT Global</span>
                    </a>
                  </li>
                  <li>
                    <a href="#contact" onClick={scrollToContact}>
                      <span>Contact</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

            {/* CTA */}
            <div className="header-btn">
              <a href="#contact" className="thm-btn" onClick={scrollToContact}>
                Get in Touch
              </a>
            </div>

            {/* Mobile toggle */}
            <div className="header-bar-mobile side-menu d-lg-none">
              <button
                className="xb-nav-mobile"
                onClick={() => setMobileActive(!mobileActive)}
              >
                <i className="far fa-bars"></i>
              </button>
            </div>
          </div>

          {/* Mobile menu */}
          <div className="xb-header-wrap">
            <div className={`xb-header-menu ${mobileActive ? "active" : ""}`}>
              <div className="xb-header-menu-scroll">
                <div
                  className="xb-menu-close xb-hide-xl xb-close"
                  onClick={() => setMobileActive(false)}
                ></div>

                <div className="xb-logo-mobile xb-hide-xl">
                  <Link to="/" rel="home">
                    <img src={companyLogo} alt={entity.name} />
                  </Link>
                </div>

                <nav className="xb-header-nav">
                  <ul className="responsivemenu">
                    <li>
                      <Link
                        to="/"
                        onClick={() => {
                          setMobileActive(false);
                          scrollTop();
                        }}
                      >
                        Home
                      </Link>
                    </li>
                    <li>
                      <a
                        href={KOT_MAIN_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        KOT Global
                      </a>
                    </li>
                    <li>
                      <a href="#contact" onClick={scrollToContact}>
                        Contact
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div className="xb-header-menu-backdrop"></div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default CompanyHeader;
